// extracted by mini-css-extract-plugin
export var settingsList = "_3m-0";
export var settingsRow = "_3m-1";
export var warningDot = "_3m-2";